module.exports = __webpack_public_path__ + "static/media/homeBookImage.0d452404.png";